import { render, staticRenderFns } from "./LockerList.vue?vue&type=template&id=1b3cb74e&"
import script from "./LockerList.vue?vue&type=script&lang=js&"
export * from "./LockerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports